import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Flex,
  Grid,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";

import { MdYoutubeSearchedFor } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import { maskCaracterEspecial, maskOnlyNumbers } from "config/functions";
// Assets
import { isEmpty } from "@chakra-ui/utils";
import {
  buscarMidiasUsuario,
  cadastrarProtocolo,
  getListaMotivosCancelamentoPedido,
  listarGratuidade,
  pesquisaCliente,
} from "config/apis/requests";
import { IsCPF, IsEmpty, maskCpfCnpj } from "config/functions";
import { IoCloseCircle, IoSearch } from "react-icons/io5";

//COMPONENTS
import InputField from "components/fields/InputField";
import HistoricoTickets from "components/HistoricoTickets/HistoticoTickets";
import Profile from "components/Profile/Profile";
import CartaoTransporte from "./components/CartaoTransporte";
import {
  default as PopOverAlert,
  default as PopOverAlertOrange,
} from "components/popAlert/popAlert";
import HistoricoGratuidade from "./components/HistoricoGratuidade";
import HistoricoPedidos from "./components/HistoricoPedidos";
import Information from "./components/Information";
import Observacoes from "./components/Observacoes";
import Rastreio from "./components/Rastreio";
import { useHistory } from "react-router-dom";
import { set } from "date-fns";
import { get } from "http";
import HistoricoMidia from "./components/HistoricoMidia";

export default function Collection() {
  const [dataUser, setDataUser] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const [pagina, setPagina] = useState(1);

  const [dataUserPrincipal, setDataUserPrincipal] = useState([]);
  const [clienteProtocolo, setClienteProtocolo] = useState("");

  const [protocolo, setProtocolo] = useState([]);
  const [arrayNew, setArrayNew] = useState([]);
  const [protocoloId, setProtocoloId] = useState(0);
  const [cpf, setCpf] = useState("");
  const [matricula, setMatricula] = useState("");

  const [cadSus, setCadSus] = useState("");
  const [msgAlert, setMsgAlert] = useState("");
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenAlerta, setIsOpenAlerta] = useState(false);
  const [pedidoAtualizar, setPedidoAtualizar] = useState(false);
  const [enderecoAtualizar, setEnderecoAtualizar] = useState(false);
  const [atualizaCartao, setAtualizaCartao] = useState(false);
  const [viewElements, setViewElements] = useState(false);
  const [viewElementBusca, setViewElementBusca] = useState(false);
  const [loginNovo, setLoginNovo] = useState(false);
  const [handleFotoAlterada, setHandleFotoAlterada] = useState(false);
  const [solicitarCartao, setSolicitarCartao] = useState(false);

  const [cepUserNovo, setCepUserNovo] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [numeroRastreio, setNumeroRastreio] = useState("");
  const [novoChamado, setNovoChamado] = useState(false);
  const continuarChamado = false;
  const [midiasContaPrincipal, setMidiasContaPrincipal] = useState([]);
  const [contaPrincipalSaldo, setContaPrincipalSaldo] = useState(0);
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [ticketUserNovo, setTicketUserNovo] = useState("");
  const [tipoErroPedido, setTipoErroPedido] = useState("");
  const [isOpenErro, setIsOpenErro] = useState(false);
  const [motivos, setMotivos] = useState([]);
  const [codigoProduto, setCodigoProduto] = useState(0);
  const [idMidiaHistorico, setIdMidiaHistorico] = useState(null);
  const [usuariosPesquisa, setUsuariosPesquisa] = useState([]);
  const recoverLoggedUser = [JSON.parse(localStorage.getItem("user"))];
  const [historicoEstudante, setHistoricoEstudante] = useState("");
  const [historicoPcd, setHistoricoPcd] = useState("");
  const [
    historicoGratuidadeEstudanteCartao,
    setHistoricoGratuidadeEstudanteCartao,
  ] = useState([]);
  const [historicoGratuidadeSeniorCartao, setHistoricoGratuidadeSeniorCartao] =
    useState([]);

  const [historicoGratuidadePcdCartao, setHistoricoGratuidadePcdCartao] =
    useState([]);
  const midiaCartaoContaPrincipal: any[] = [];
  let midiasUsuario: any[] = [];

  interface PerfisUsuario {
    perfis: string[];
  }

  const perfisDesejados = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_PCD",
    "SUPERVISOR_SENIOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_ESTUDANTE",
    "CADASTRO_PDC",
    "CONSULTA_PCD",
    "CONSULTA_SENIOR",
    "MEDICO_PCD",
    "CONSULTA_ESTUDANTE",
    "CADASTRO_PREFEITURA",
    "ATENDIMENTO_BIOMETRIA",
    "AUDITORIA",
  ];
  const perfisDesejadosBotaoMatricula = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_ESTUDANTE",
    "CONSULTA_ESTUDANTE",
  ];

  const perfisDesejadosBotaoPCD = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_PCD",
    "CONSULTA_PCD",
    "MEDICO_PCD",
  ];

  const perfisConsultaEstudante = ["CONSULTA_ESTUDANTE", "CADASTRO_ESTUDANTE"];
  const perfisConsultaPCD = ["CONSULTA_PCD", "CADASTRO_PCD"];
  const perfisConsultaSenior = ["CONSULTA_SENIOR"];
  const perfisLojas = ["ADMINISTRADOR", "SUPERVISOR_LOJA", "ATENDENTE_LOJA"];
  const perfilAuditoria = ["ATENDIMENTO_BIOMETRIA", "AUDITORIA"];

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 5000); // 3 segundos

    return () => clearTimeout(timer);
  }, []);

  const usuarios: PerfisUsuario[] = [
    {
      perfis: recoverLoggedUser[0]?.perfis,
    },
  ];

  let dataLogin;

  const handleOpenAlert = (status: boolean) => {
    setIsOpenAlerta(status);
  };

  const ticketGerado = (status: any) => {
    setProtocolo(status || 0);
    setProtocoloId(status?.id || "");
    setTicketUserNovo(status || 0);
  };

  const codigoProdutoParaPedido = (codProduto: any) => {
    setCodigoProduto(codProduto);
  };

  const pesquisaHistoricoMidia = (idMidia: any) => {
    setIdMidiaHistorico(idMidia);
  };

  const handleAtualizaPedido = () => {
    setPedidoAtualizar(true);
  };

  const handleAtualizaEndereco = () => {
    setEnderecoAtualizar(true);
  };

  const handleAtualizaCartao = (status: any) => {
    if (status === true) {
      setPedidoAtualizar(!status);
    }
    setArrayNew([]);
    setAtualizaCartao(!atualizaCartao);
  };

  const handleFotoIndex = (foto: any) => {
    setHandleFotoAlterada(foto);
  };

  const handleFotoAlteradaIndex = (foto: any) => {
    setHandleFotoAlterada(foto);
  };

  const handleSolicitarCartao = async (status: any, cpfNovo: any) => {
    dataLogin = await pesquisaCliente({
      email: null,
      nome: null,
      numeroDocumento: cpfNovo.replace(/[^\d]+/g, ""),
      tipoBusca: "TODOS",
      tipoPessoa: "F",
    });
    setDataUserPrincipal(dataLogin[0]);
    setDataUser(dataLogin[0]);
    setViewElementBusca(true);
    setSolicitarCartao(status);
    window.scrollTo(0, 0);
  };

  const handleCpfProtocolo = (status: any) => {
    setClienteProtocolo(status);
  };

  const handleCepNovoUser = (cep: any) => {
    setCepUserNovo(cep);
  };

  const handleValorMatricula = (event: { target: { value: any } }) => {
    const { value } = event.target;
    setMatricula(value);
  };

  const handleValorCadSus = (event: { target: { value: any } }) => {
    const { value } = event.target;
    setCadSus(value);
  };

  const handleChangeMask = (event: { target: { value: any } }) => {
    const { value } = event.target;
    if (value.length < 15) {
      const valueRet = maskCpfCnpj(value);
      setCpf(valueRet);
    }
  };

  const confirmarAtendimento = (row: any) => {
    setLoginNovo(false);
    setLoading(false);
    setNovoChamado(true);

    if (!IsEmpty(row)) {
      if (row?.tipoDocumento.codigo === 6) {
        setCpf("");
      } else if (row?.tipoDocumento.codigo === 4) {
        setCpf("");
      } else if (historicoEstudante && row.numeroDocumento !== "") {
        setCpf(maskCpfCnpj(row?.numeroDocumento));
      } else if (historicoPcd && row.numeroDocumentoAlternativo !== "") {
        setCpf(maskCpfCnpj(row?.numeroDocumento));
      }
      //setCpf(maskCpfCnpj(row?.numeroDocumento));
      setNomeUsuario(row?.nome);
    } else {
      setDataUser([]);
      setNomeUsuario("");
    }

    setLoading(false);

    if (!isEmpty(dataUserPrincipal) || !IsEmpty(row)) {
      setViewElementBusca(true);
      setLoginNovo(false);
      setDataUser(dataUserPrincipal[0] || row);
      setLoading(false);
      setViewElements(true);
      setViewElementBusca(true);
      onOpen();
      onClose();
    } else if (isEmpty(dataUserPrincipal) && IsEmpty(row)) {
      setLoginNovo(true);
      setLoading(false);
      setViewElements(true);
      setViewElementBusca(true);
      onClose();
    } else {
      handleOpenAlert(true);
      setMsgAlert("Erro no sistema, favor tentar novamente!");
    }

    // if ((novoChamado && !IsEmpty(dataUserPrincipal)) || !IsEmpty(row)) {
    //   cadastrarProtocolo(row, "").then(function (result) {
    //     if (result.id) {
    //       setProtocolo(result);
    //       setProtocoloId(result.id);
    //     }
    //   });
    // } else if (continuarChamado) {
    //   setProtocolo([]);
    // }
  };

  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      onClickPesquisar();
    }
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("stayLogged");

    // setTipoErroPedido("Login expirado, faça o login novamente!");
    // setIsOpenErro(!isOpenErro);
    setLoading(false);
    //setTimeout(function () {
    window.location.href = "/atendimento#/auth/sign-in";
    window.location.reload();
    //}, 3000);
  };

  const onClickLimparFiltros = async () => {
    setCpf("");
    setNomeUsuario("");
    setNumeroRastreio("");
    setArrayNew([]);
    setDataUser([]);
    setUsuariosPesquisa([]);
    setDataUserPrincipal([]);
    setMatricula("");
    setCepUserNovo("");
  };

  const onClickPesquisar = async () => {
    setLoading(true);
    setUsuariosPesquisa([]);
    setDataUser([]);
    setDataUserPrincipal([]);
    if (nomeUsuario || cpf || matricula || cadSus || numeroRastreio) {
      dataLogin = await pesquisaCliente({
        email: null,
        nome: nomeUsuario,
        numeroDocumento:
          matricula.replace(/[^\d]+/g, "") ||
          cpf.replace(/[^\d]+/g, "") ||
          cadSus.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        numeroRastreio: numeroRastreio,
        pagina: 1,
        quantidadePorPaginacao: 10,
      });
      if (dataLogin === 403 || dataLogin === 401) {
        logout();
      } else if (dataLogin === 400 || dataLogin === 404 || dataLogin === 500) {
        handleOpenAlert(true);
        setMsgAlert(
          "Erro ao fazer pesquisa! Entre em contato com o administrador do sistema."
        );
        setLoading(false);
      } else {
        if (!IsEmpty(dataLogin)) {
          if (dataLogin.length < 5) {
            setHasMore(false);
          } else {
            setHasMore(true);
            setPagina(2);
          }
          setViewElements(false);
          setUsuariosPesquisa(dataLogin);
          setLoading(false);
        } else {
          setUsuariosPesquisa([]);
          setViewElements(false);
          if (cpf) {
            if (
              IsCPF(cpf) ||
              !IsEmpty(matricula) ||
              !IsEmpty(cadSus) ||
              !IsEmpty(numeroRastreio)
            ) {
              if (
                usuarios[0]?.perfis.some((perfil: string) =>
                  perfisDesejados.includes(perfil)
                ) &&
                window.config.tenant !== "macae"
              ) {
                onOpen();
              } else {
                handleOpenAlertErro();
                setTipoErroPedido("Usuário(s) não encontrado(s)!");
              }
            } else {
              handleOpenAlert(true);
              setMsgAlert("Cpf inválido!");
            }
          } else {
            handleOpenAlertErro();
            setTipoErroPedido("Usuário(s) não encontrado(s)!");
          }
          setLoading(false);
        }
      }
      setLoading(false);
    } else {
      handleOpenAlert(true);
      setMsgAlert("Os campos de busca devem ser preenchidos!");
      setLoading(false);
    }
    setLoading(false);
  };

  const fetchDataMidias = async (dados: any) => {
    if (!isEmpty(dados) && historicoEstudante === "" && historicoPcd === "") {
      setLoading(true);
      midiasContaPrincipal.splice(0, midiaCartaoContaPrincipal.length);
      const historicoEstudante1 = await listarGratuidade(dados.codigo, 1);
      const historicoPcd1 = await listarGratuidade(dados.codigo, 3);
      const historicoSenior1 = await listarGratuidade(dados.codigo, 2);
      setHistoricoGratuidadeEstudanteCartao(historicoEstudante1);
      setHistoricoGratuidadeSeniorCartao(historicoSenior1);
      setHistoricoGratuidadePcdCartao(historicoPcd1);

      setHistoricoEstudante(
        historicoEstudante1?.statusGratuidade?.descricao || ""
      );

      const regrasAtuais = historicoPcd1?.regraGratuidadeList?.reduce(
        (acc: Record<number, any>, regra: any) => {
          const tipoId = regra.tipoRegraGratuidade.id;
          if (
            !acc[tipoId] ||
            new Date(regra.dataInclusao) > new Date(acc[tipoId].dataInclusao)
          ) {
            acc[tipoId] = regra;
          }
          return acc;
        },
        {} // Inicializa como um objeto vazio
      );

      setHistoricoPcd(historicoPcd1?.statusGratuidade?.descricao || "");

      midiasUsuario = await buscarMidiasUsuario(dados.codigo);
      if (midiasUsuario.length > 0) {
        if (
          usuarios[0]?.perfis.some((perfil: string) =>
            perfisConsultaEstudante.includes(perfil)
          )
        ) {
          const novoArray = midiasUsuario.filter(
            (item) =>
              item.idProduto === 3 ||
              item.gratuidades?.some(
                (gratuidade: any) =>
                  gratuidade.id === 1 ||
                  gratuidade.id === 3 ||
                  gratuidade.id === null
              )
          );
          setArrayNew(
            novoArray?.map((item) => ({
              ...item,
              midias: item.midias.filter(
                (midia: any) =>
                  midia.idTipoMidia !== 2 && midia.idTipoMidia !== 3
              ),
            }))
          );
        } else if (
          usuarios[0]?.perfis.some((perfil: string) =>
            perfisConsultaPCD.includes(perfil)
          )
        ) {
          const novoArray = midiasUsuario.filter(
            (item) =>
              item.idProduto === 3 &&
              item.gratuidades?.some(
                (gratuidade: any) => gratuidade.id === 3 || gratuidade.id === 1
              )
          );

          setArrayNew(
            novoArray?.map((item) => ({
              ...item,
              midias: item.midias.filter(
                (midia: any) =>
                  midia.idTipoMidia !== 2 && midia.idTipoMidia !== 3
              ),
            }))
          );
        } else if (
          usuarios[0]?.perfis.some((perfil: string) =>
            perfisConsultaSenior.includes(perfil)
          )
        ) {
          const novoArray = midiasUsuario.filter(
            (item) =>
              item.idProduto === 3 &&
              item.gratuidades?.some((gratuidade: any) => gratuidade.id === 2)
          );
          setArrayNew(
            novoArray?.map((item) => ({
              ...item,
              midias: item.midias.filter(
                (midia: any) =>
                  midia.idTipoMidia !== 2 && midia.idTipoMidia !== 3
              ),
            }))
          );
        } else {
          setArrayNew(
            midiasUsuario?.map((item) => ({
              ...item,
              midias: item.midias.filter(
                (midia: any) =>
                  midia.idTipoMidia !== 2 && midia.idTipoMidia !== 3
              ),
            }))
          );
        }
      }

      setMidiasContaPrincipal(midiaCartaoContaPrincipal);
      setContaPrincipalSaldo(0);
      //setTipoPrincipal(0);
      setLoading(false);
    }
  };

  const handleOpenAlertErro = () => {
    setIsOpenErro(!isOpenErro);
  };

  const fetchMoreData = () => {
    if (hasMore) {
      pesquisaCliente({
        email: null,
        nome: nomeUsuario,
        numeroDocumento:
          matricula.replace(/[^\d]+/g, "") ||
          cpf.replace(/[^\d]+/g, "") ||
          cadSus.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        numeroRastreio: numeroRastreio,
        pagina: pagina,
        quantidadePorPaginacao: 10,
      }).then(async (resultado) => {
        if (resultado.length > 0) {
          const cont = pagina + 1;
          setPagina(cont);

          // setPesquisar(false);
          setUsuariosPesquisa((prevItems) => [...prevItems, ...resultado]);
        } else if (resultado.length < 10) {
          //setPesquisar(false);

          setHasMore(false);
        }
      });
    }
  };

  useEffect(() => {
    if (IsEmpty(dataUser)) {
      window.scrollTo(0, 0);
    } else if (!IsEmpty(dataUser) && IsEmpty(arrayNew)) {
      fetchDataMidias(dataUser);
      //setRecoverLoggedUser([JSON.parse(localStorage.getItem("user"))]);
    }
  }, [dataUser, atualizaCartao]);

  useEffect(() => {
    fetchDataMidias(dataUser);
  }, [pedidoAtualizar]);

  useEffect(() => {
    const getMotivos = () => {
      getListaMotivosCancelamentoPedido().then(function (result: any) {
        if (result !== 400 && result !== 404 && result !== 500) {
          localStorage.setItem("motivosCancelamento", JSON.stringify(result));
        } else if (result === 403 || result === 401 || isEmpty(result)) {
          logout();
        }
      });
    };
    if (localStorage.getItem("motivosCancelamento") === null) {
      getMotivos();
    }
  });

  const getMarginTop = (usuariosLength: any, tenant: any) => {
    const macae = tenant === "macae";
    if (!macae) {
      if (usuariosLength === 0) return "-204px";
      if (usuariosLength >= 10) return "-764px";
      if (usuariosLength >= 7) return "-694px";
      if (usuariosLength === 5) return "-644px";
      if (usuariosLength === 4) return "-564px";
      if (usuariosLength > 2) return "-474px";
      if (usuariosLength === 2) return "-437px";
      if (usuariosLength <= 1) return "-324px";
      return "-274px";
    }

    // Caso seja tenant "macae"
    if (usuariosLength >= 10) return "-764px";
    if (usuariosLength >= 7) return "-504px";
    if (usuariosLength === 5) return "-624px";
    if (usuariosLength === 4) return "-544px";
    if (usuariosLength > 2) return "-454px";
    if (usuariosLength === 2) return "-377px";
    if (usuariosLength <= 1) return "-304px";
    return "-554px";
  };

  return (
    <Box pt={{ base: "140px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <PopOverAlertOrange
        handleOpenAlert={handleOpenAlertErro}
        isOpen={isOpenErro}
        title="Ops..."
        subtitle={tipoErroPedido}
      />
      <Grid
        mb="20px"
        gridTemplateColumns={{ xl: "repeat(1, 1fr)", "1xl": "1fr 0.46fr" }}
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}
      >
        <Flex flexDirection="column" mt={"15px"}>
          <Flex
            direction={{ base: "column", md: "row" }}
            alignContent={"center"}
            justifySelf={"center"}
            gap="10px"
            px={{ base: "10px", md: "0" }}
            visibility={viewElements ? "hidden" : "visible"}
          >
            <InputField
              isRequired={true}
              ml={{ base: "0", md: "25px" }}
              w={{ base: "100%", md: "150px" }}
              h="50px"
              id="cpf"
              label="CPF"
              value={cpf}
              onChange={handleChangeMask}
              onKeyDown={handleKeyDown}
            />
            {usuarios[0]?.perfis?.some(
              (perfil: string) =>
                perfisDesejadosBotaoMatricula.includes(perfil) &&
                window.config.tenant !== "macae"
            ) && (
              <InputField
                isRequired={true}
                ml={{ base: "0", md: "25px" }}
                w={{ base: "100%", md: "200px" }}
                h="50px"
                id="cpf"
                value={matricula}
                label="Matrícula"
                onChange={handleValorMatricula}
                onKeyDown={handleKeyDown}
              />
            )}
            {usuarios[0]?.perfis?.some(
              (perfil: string) =>
                perfisDesejadosBotaoPCD.includes(perfil) &&
                window.config.tenant !== "macae"
            ) && (
              <InputField
                isRequired={true}
                ml={{ base: "0", md: "25px" }}
                w={{ base: "100%", md: "200px" }}
                h="50px"
                id="cns"
                label="Nº CNS"
                value={cadSus}
                onChange={handleValorCadSus}
                onKeyDown={handleKeyDown}
              />
            )}
            <InputField
              isRequired={true}
              ml={{ base: "0", md: "25px" }}
              w={{ base: "100%", md: "350px" }}
              h="50px"
              id="nome"
              label="Nome"
              value={nomeUsuario}
              onKeyDown={handleKeyDown}
              onChange={(e: {
                target: { value: React.SetStateAction<string> };
              }) => setNomeUsuario(e.target.value)}
            />
            {window.config.tenant === "macae" && (
              <Flex gap="10px" mt={{ base: "10px", md: "30px" }} ml={{ base: "0", md: "25px" }}>
                <IconButton
                  aria-label="share"
                  w="40px"
                  h="40px"
                  variant="brand"
                  borderRadius="20%"
                  onClick={onClickPesquisar}
                  isLoading={loading}
                >
                  <Icon w="14px" h="14px" as={IoSearch} color="white" />
                </IconButton>

                <IconButton
                  aria-label="share"
                  w="40px"
                  h="40px"
                  variant="brand"
                  borderRadius="20%"
                  onClick={onClickLimparFiltros}
                >
                  <Icon w="14px" h="14px" as={IoCloseCircle} color="white" />
                </IconButton>
              </Flex>
            )}

            <PopOverAlert
              status={"error"}
              handleOpenAlert={handleOpenAlert}
              isOpen={isOpenAlerta}
              title="Ops..."
              subtitle={msgAlert}
            />
          </Flex>

          {window.config.tenant !== "macae" && (
            <Flex
              direction={{ base: "column", md: "row" }}
              alignContent={"center"}
              justifySelf={"center"}
              gap="10px"
              px={{ base: "10px", md: "0" }}
              visibility={viewElements ? "hidden" : "visible"}
            >
              <InputField
                isRequired={true}
                ml={{ base: "0", md: "25px" }}
                w={{ base: "100%", md: "250px" }}
                h="50px"
                id="nome"
                label="Número rastreio"
                value={numeroRastreio}
                onKeyDown={handleKeyDown}
                onChange={(e: {
                  target: { value: React.SetStateAction<string> };
                }) => setNumeroRastreio(e.target.value)}
              />

              <Flex gap="10px" mt={{ base: "10px", md: "30px" }} ml={{ base: "0", md: "25px" }}>
                <IconButton
                  aria-label="share"
                  w="40px"
                  h="40px"
                  variant="brand"
                  borderRadius="20%"
                  onClick={onClickPesquisar}
                  isLoading={loading}
                >
                  <Icon w="14px" h="14px" as={IoSearch} color="white" />
                </IconButton>

                <IconButton
                  aria-label="share"
                  w="40px"
                  h="40px"
                  variant="brand"
                  borderRadius="20%"
                  onClick={onClickLimparFiltros}
                >
                  <Icon w="14px" h="14px" as={IoCloseCircle} color="white" />
                </IconButton>
              </Flex>
            </Flex>
          )}

          <Box
            overflowX="auto"
            maxW="100vw"
            h={"490px"}
            pb="17px"
            mb={"10px"}
            visibility={!viewElements ? "visible" : "hidden"}
          >
            <TableContainer
              visibility={
                !viewElements && usuariosPesquisa.length > 0
                  ? "visible"
                  : "hidden"
              }
              width={"100%"}
              alignSelf={"left"}
              borderBottomStartRadius={"12px"}
            >
              <Table variant="striped" colorScheme="gray">
                <Thead>
                  <Tr>
                    <Th minW="200px">NOME</Th>
                    <Th minW="150px">DOCUMENTO </Th>
                    <Th></Th>
                    <Th></Th>
                  </Tr>
                </Thead>
              </Table>
            </TableContainer>
          </Box>
          <Box
            maxW="100vw"
            whiteSpace="nowrap"
            pb="17px"
            mt={"-400px"}
            visibility={!viewElements ? "visible" : "hidden"}
          >
            <Flex
              direction="column"
              width={{ xl: "100%", md: "100%", lg: "100%" }}
            >
              <InfiniteScroll
                dataLength={usuariosPesquisa.length}
                next={fetchMoreData}
                hasMore={true}
                loader={
                  <Flex
                    justify="center"
                    px="10px"
                    pt="5px"
                    mb="25px"
                    mt="20px"
                    alignItems={"center"}
                    justifySelf={"center"}
                  >
                    {!hasMore ? (
                      <Text color={"black"} fontSize="lg" fontWeight="300">
                        {usuariosPesquisa.length > 0 &&
                          "Todos os dados carregados"}
                      </Text>
                    ) : (
                      usuariosPesquisa.length > 0 && (
                        <Flex>
                          <Button
                            variant="action"
                            px="24px"
                            fontSize="sm"
                            fontWeight="700"
                            disabled={hasMore ? false : true}
                            onClick={() => fetchMoreData()}
                          >
                            {hasMore
                              ? "Carregar mais dados..."
                              : "Não há mais dados"}
                          </Button>
                        </Flex>
                      )
                    )}
                  </Flex>
                }
              >
                <TableContainer
                  width={"100%"}
                  alignSelf={"left"}
                  borderBottomStartRadius={"12px"}
                  style={{ overflowY: "auto", maxHeight: "500px" }}
                >
                  <Table variant="striped" colorScheme="gray">
                    <Tbody>
                      {usuariosPesquisa.map((row, index) => {
                        return (
                          <Tr key={index}>
                            <Td minW="200px">{row.nome}</Td>
                            <Td minW="150px">
                              {" "}
                              {row.tipoDocumento.codigo === 4
                                ? maskOnlyNumbers(row.numeroDocumento)
                                : row.tipoDocumento.codigo === 1 ||
                                  row.tipoDocumento.codigo === 2
                                ? maskCaracterEspecial(
                                    maskCpfCnpj(row.numeroDocumento)
                                  )
                                : maskOnlyNumbers(row.numeroDocumento)}
                            </Td>
                            <Td></Td>
                            <Td>
                              {" "}
                              {isEmpty(row?.dataCancelamento) ? (
                                <Button
                                  variant="action"
                                  px="24px"
                                  fontSize="sm"
                                  fontWeight="700"
                                  onClick={() => confirmarAtendimento(row)}
                                >
                                  Iniciar atendimento{" "}
                                </Button>
                              ) : (
                                <Text
                                  fontSize="sm"
                                  color={"red"}
                                  fontWeight="700"
                                >
                                  Conta cancelada
                                </Text>
                              )}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                  {usuariosPesquisa.length > 0 && (
                    <Divider mb="20px" mt="25px" />
                  )}
                </TableContainer>
              </InfiniteScroll>
            </Flex>
          </Box>
          {/* {usuariosPesquisa.length === 0 && cpf || nomeUsuario ?
            <Text
            color={textColorPrimary}
            fontSize={"16px"}
            fontWeight={"700"}
            mt={"-500px"}
            textColor={"red.300"}
            ml={"25px"}
          >
          Usuário não encontrado!
          </Text>
          : null} */}
          {!isEmpty(protocolo) ? (
            <Flex
              direction="column"
              visibility={viewElements ? "visible" : "hidden"}
              id="fotoElementoUsuario"
              mt={{
                base: "0px",
                xl: "-0px",
              }}
              ml={{
                base: "0px",
                md: "-48px",
                xl: "-103px",
              }}
              style={{
                position: window.innerWidth < 768 ? "relative" : "fixed",
                top: window.innerWidth < 768 ? "auto" : "8%",
                left: window.innerWidth < 768 ? "auto" : "57%",
                width: window.innerWidth < 768 ? "100%" : "26%",
                transform: window.innerWidth < 768 ? "none" : "translate(-50%, -50%)",
                padding: "20px",
                zIndex: 9999,
              }}
            >
              <Text color={textColorPrimary} fontSize={"16px"}>
                Protocolo:
              </Text>
              <Text
                color={textColorPrimary}
                fontSize={"20px"}
                fontWeight={"700"}
              >
                {protocoloId ?? protocolo}
              </Text>
            </Flex>
          ) : null}

          <Flex
            direction="column"
            mt={getMarginTop(usuariosPesquisa.length, window.config.tenant)}
            h="100%" 
            visibility={viewElements ? "visible" : "hidden"}
          >
            {!IsEmpty(dataUser) ? (
              <Flex
                direction="column"
                visibility={viewElements ? "visible" : "hidden"}
                id="fotoElementoUsuario2"
                mt={{
                  base: "0px",
                  xl: "-0px",
                }}
                ml={{
                  base: "0px",
                  md: "-48px",
                  xl: "-103px",
                }}
                style={{
                  position: window.innerWidth < 768 ? "relative" : "fixed",
                  top: window.innerWidth < 768 ? "auto" : "7.5%",
                  left: window.innerWidth < 768 ? "auto" : "74%",
                  width: window.innerWidth < 768 ? "100%" : "26%",
                  transform: window.innerWidth < 768 ? "none" : "translate(-50%, -50%)",
                  padding: "20px",
                  zIndex: 9999,
                }}
              >
                <Profile
                  dataUser={dataUser}
                  handleFotoIndex={handleFotoIndex}
                  fotoAlteradaUserData={handleFotoAlterada}
                  cpfBusca={cpf}
                  protocolo={protocolo}
                />
              </Flex>
            ) : null}
            <Flex mt={window.config.tenant === "macae" ? { base: "0px", md: "-40px" } : { base: "0px", md: "-95px" }}>
              <Button
                variant="darkBrand"
                fontSize="sm"
                mb={"15px"}
                borderRadius="16px"
                p="25px"
                visibility={viewElementBusca ? "visible" : "hidden"}
                leftIcon={<MdYoutubeSearchedFor size="20px" />}
                onClick={() => {
                  setViewElementBusca(false);
                  setTimeout(() => {
                    setNovoChamado(false);
                    setCpf("");
                    setMidiasContaPrincipal([]);
                    setNomeUsuario("");
                    setNumeroRastreio("");
                    setProtocoloId(0);
                    setProtocolo([]);
                    setArrayNew([]);
                    setDataUser([]);
                    setViewElements(!viewElements);
                    setUsuariosPesquisa([]);
                    setDataUserPrincipal([]);
                    setMatricula("");
                    setCepUserNovo("");
                    setCadSus("");
                    setHandleFotoAlterada(false);
                    setPagina(1);
                    setLoading(false);
                    setHasMore(false);
                    setHistoricoGratuidadeEstudanteCartao([]);
                    setHistoricoGratuidadeSeniorCartao([]);
                    setHistoricoGratuidadePcdCartao([]);
                    setHistoricoEstudante("");
                    setHistoricoPcd("");
                  }, 100);
                }}
              >
                Nova busca
              </Button>
            </Flex>

            <Flex flexDirection="column">
              <Information
                dataUser={dataUser}
                cpfBusca={cpf}
                matriculaBusca={matricula}
                cadSusBusca={cadSus}
                docAlternativo={matricula || cadSus}
                cpfHandleProtocolo={handleCpfProtocolo}
                loginNovo={loginNovo}
                handleAtualizaEndereco={handleAtualizaEndereco}
                handleFotoAlterada={handleFotoAlteradaIndex}
                fotoAlteradaUserData={handleFotoAlterada}
                solicitarCartao={handleSolicitarCartao}
                handleCepNovoUser={handleCepNovoUser}
                ticketGerado={ticketGerado}
              />

              <>
                {!IsEmpty(dataUser) ? (
                  <>
                    <Grid
                      templateColumns={{
                        base: "repeat(2, fr)",
                        "2xl": "650fr 720fr",
                      }}
                      gap="20px"
                      display={{ base: "block", lg: "grid" }}
                    >
                      <Flex direction={"row"} alignContent={"center"}>
                        {!IsEmpty(dataUser) &&
                        !IsEmpty(arrayNew) &&
                        usuarios[0]?.perfis.some((perfil: string) =>
                          perfisDesejados.includes(perfil)
                        ) ? (
                          <CartaoTransporte
                            dataUser={dataUser ?? dataUserPrincipal}
                            midiasContaPrincipal={arrayNew}
                            atualizaCartao={handleAtualizaCartao}
                            saldoContaPrincipal={contaPrincipalSaldo}
                            solicitarCartao={solicitarCartao}
                            atualizaPedido={handleAtualizaPedido}
                            enderecoAtualizar={enderecoAtualizar}
                            cepUserNovo={cepUserNovo}
                            codigoProdutoParaPedido={codigoProdutoParaPedido}
                            pesquisaHistoricoMidia={pesquisaHistoricoMidia}
                            historicoGratuidadeEstudanteCartao={
                              historicoGratuidadeEstudanteCartao
                            }
                            historicoGratuidadeSeniorCartao={
                              historicoGratuidadeSeniorCartao
                            }
                            historicoGratuidadePcdCartao={
                              historicoGratuidadePcdCartao
                            }
                            //tipo={tipoPrincipal}
                          />
                        ) : (
                          <>
                            {loading && arrayNew.length === 0 ? (
                              <Flex
                                flexDirection="column"
                                justifyContent="center"
                                align="center"
                                width={"100%"}
                              >
                                <CircularProgress
                                  isIndeterminate
                                  color="green.300"
                                  size="75px"
                                />
                              </Flex>
                            ) : arrayNew.length === 0 &&
                              loading === false &&
                              usuarios[0]?.perfis.some(
                                (perfil: string) =>
                                  !perfisConsultaEstudante.includes(perfil) ||
                                  !perfisConsultaSenior.includes(perfil) ||
                                  !perfisConsultaPCD.includes(perfil) ||
                                  perfisLojas.includes(perfil)
                              ) ? (
                              <Flex
                                direction="row"
                                align="center"
                                justify="center"
                              >
                                <Text
                                  color="red"
                                  align="center"
                                  mt="20%"
                                  width={"100%"}
                                  fontSize="25px"
                                  fontWeight="700"
                                  lineHeight="100%"
                                >
                                  Erro ao consultar mídia, contate o
                                  administrador!
                                </Text>
                              </Flex>
                            ) : (
                              <Flex
                                direction="row"
                                align="center"
                                justify="center"
                                width={"100%"}
                              >
                                <Text
                                  color="red"
                                  align="center"
                                  mt="20%"
                                  fontSize="25px"
                                  fontWeight="700"
                                  lineHeight="100%"
                                >
                                  Usuário sem permissão para ver mídias
                                </Text>
                              </Flex>
                            )}
                          </>
                        )}
                      </Flex>

                      <Flex
                        direction="column"
                        gridArea={{
                          md: "1 / 2 / 2 / 3",
                          "3xl": "1 / 2 / 2 / 3",
                        }}
                      >
                        <HistoricoMidia idMidia={idMidiaHistorico} />
                        <HistoricoPedidos
                          dataUser={dataUser}
                          pedidoAtualizar={pedidoAtualizar}
                          motivos={JSON.parse(
                            localStorage.getItem("motivosCancelamento") || "[]"
                          )}
                          codigoProduto={codigoProduto}
                        />

                        {window.config.tenant !== "macae" && (
                          <>
                            <HistoricoTickets
                              dataUser={dataUser}
                              ticketUserNovo={ticketUserNovo}
                            />
                          </>
                        )}
                      </Flex>
                    </Grid>

                    <Grid
                      templateColumns={{
                        base: "repeat(2, fr)",
                        "2xl": "650fr 720fr",
                      }}
                      gap="20px"
                      display={{ base: "block", lg: "grid" }}
                    >
                      {dataUser &&
                        arrayNew &&
                        window.config.tenant !== "macae" && (
                          <Flex width={"99%"}>
                            <Rastreio
                              dataUser={dataUser}
                              midias={arrayNew}
                              codigoProduto={codigoProduto}
                            />
                          </Flex>
                        )}
                      {window.config.tenant !== "macae" &&
                        (historicoGratuidadeEstudanteCartao ||
                          historicoGratuidadePcdCartao ||
                          historicoGratuidadeSeniorCartao) && (
                          <HistoricoGratuidade
                            dataUser={dataUser ?? []}
                            historicoGratuidadeEstudanteCartao={
                              historicoGratuidadeEstudanteCartao
                            }
                            historicoGratuidadeSeniorCartao={
                              historicoGratuidadeSeniorCartao
                            }
                            historicoGratuidadePcdCartao={
                              historicoGratuidadePcdCartao
                            }
                          />
                        )}
                    </Grid>

                    {/* <HistoricoAuditoria dataUser={dataUser ?? []} /> */}
                    {window.config.tenant !== "macae" && (
                      <Observacoes
                        dataUser={dataUser ?? []}
                        clienteProtocolo={clienteProtocolo}
                        cpfBusca={cpf}
                        protocolo={protocolo}
                        ticketGerado={ticketUserNovo}
                      />
                    )}
                  </>
                ) : null}
              </>
            </Flex>
          </Flex>
        </Flex>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            alignSelf={"center"}
            bgColor={!IsEmpty(dataUserPrincipal) ? "white" : "green.600"}
            w={"630px"}
          >
            <ModalHeader>
              {!IsEmpty(dataUserPrincipal) ? (
                <Text fontSize="xl" color={"black"} fontWeight="bold">
                  Deseja iniciar atendimento?
                </Text>
              ) : (
                <Text fontSize="xl" color={"white"} fontWeight="bold">
                  Deseja iniciar o cadastro / atendimento a este novo usuário?
                </Text>
              )}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {!IsEmpty(dataUserPrincipal) ? (
                <Flex direction={"column"}>
                  {cpf ? (
                    <Text fontSize="xl" color={"black"}>
                      <b>Cpf:</b> {maskCpfCnpj(cpf)}
                    </Text>
                  ) : null}
                  {matricula ?? (
                    <Text fontSize="xl" color={"black"}>
                      <b>Matrícula:</b> {matricula}
                    </Text>
                  )}
                  {cadSus ?? (
                    <Text fontSize="xl" color={"black"}>
                      <b>Nº CNS:</b> {cadSus}
                    </Text>
                  )}

                  <Text fontSize="xl" color={"black"}>
                    <b>Nome:</b> {nomeUsuario ?? dataUserPrincipal[0]?.nome}
                  </Text>
                </Flex>
              ) : (
                <Flex direction={"column"}>
                  {cpf ? (
                    <Text fontSize="xl" color={"white"}>
                      <b>Cpf:</b> {cpf}
                    </Text>
                  ) : null}

                  {matricula ? (
                    <Text fontSize="xl" color={"white"}>
                      <b>Matrícula:</b> {matricula}
                    </Text>
                  ) : null}
                  {cadSus ? (
                    <Text fontSize="xl" color={"white"}>
                      <b>Nº CNS:</b> {cadSus}
                    </Text>
                  ) : null}
                </Flex>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="brand"
                mr={3}
                onClick={() => confirmarAtendimento(null)}
              >
                Confirmar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Grid>
    </Box>
  );
}
